// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckboxHandlerController from "./checkbox_handler_controller"
application.register("checkbox-handler", CheckboxHandlerController)

import ConfirmationDialogController from "./confirmation_dialog_controller"
application.register("confirmation-dialog", ConfirmationDialogController)

import CostSummaryChartController from "./cost_summary_chart_controller"
application.register("cost-summary-chart", CostSummaryChartController)

import DataCatalogSlimSelectController from "./data_catalog_slim_select_controller"
application.register("data-catalog-slim-select", DataCatalogSlimSelectController)

import DeleteConfirmationDialogController from "./delete_confirmation_dialog_controller"
application.register("delete-confirmation-dialog", DeleteConfirmationDialogController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DisplayUploadedFileNameController from "./display_uploaded_file_name_controller"
application.register("display-uploaded-file-name", DisplayUploadedFileNameController)

import DistributionChartController from "./distribution_chart_controller"
application.register("distribution-chart", DistributionChartController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FilterSelectorController from "./filter_selector_controller"
application.register("filter-selector", FilterSelectorController)

import FormDialogController from "./form_dialog_controller"
application.register("form-dialog", FormDialogController)

import PopperController from "./popper_controller"
application.register("popper", PopperController)

import ProfileTabsController from "./profile_tabs_controller"
application.register("profile-tabs", ProfileTabsController)

import SelectAllController from "./select_all_controller"
application.register("select-all", SelectAllController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import SpotInstanceSelectorController from "./spot_instance_selector_controller"
application.register("spot-instance-selector", SpotInstanceSelectorController)

import TemplateController from "./template_controller"
application.register("template", TemplateController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import TrialDateSelectorController from "./trial_date_selector_controller"
application.register("trial-date-selector", TrialDateSelectorController)
